export default __webpack_public_path__ + "static/no-events-banner-10a08b89169c0ec33b8caf5782a95ee7.jpg";